import React from 'react'
import { useLocation } from 'react-router-dom'
import Header from '../landing/Header'
import Footer from '../landing/Footer'

interface LayoutProps {
  children: React.ReactNode
  fullWidth?: boolean
  hideFooter?: boolean
  hideHeader?: boolean
}

const Layout: React.FC<LayoutProps> = ({ children, fullWidth = false, hideFooter = false, hideHeader = false }) => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {!hideHeader && <Header />}
      <div className={`flex-1 ${fullWidth ? "w-full px-4 sm:px-6 lg:px-8 py-8" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"}`}>
        {children}
      </div>
      {!hideFooter && <Footer isHomePage={isHomePage} />}
    </div>
  )
}

export default Layout 